require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-hyper-personalisation.json") })
        }
      }, "path---authors-hyper-personalisation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-hyper-personalisation!./.cache/json/authors-hyper-personalisation.json
// module id = 1288
// module chunks = 231608221292675